module.exports = __webpack_public_path__ + "static/media/HINDALCO.6355f0da.txt";